module.exports = __webpack_public_path__ + "static/media/intercom-chat-icon.b70ed4b5.png";